<template>
  <div class="bg-white vh-100 vw-100 d-flex flex-column align-items-center justify-content-center">
    <div class="div-circle-rotate position-relative bg-gradient-danger rounded-circle d-flex flex-column align-items-center justify-content-center p-9">
    </div>
    <div class="position-absolute d-flex flex-column align-items-center justify-content-center p-9 text-center text-white">
      <h1 class="text-white display-1">404</h1>
      <p class="text-white" style="font-size: 18px;">Lo sentimos, la página que busca no existe.</p>
      <router-link to="/login" class="mt-4">
       <base-button type="secondary">Regresar</base-button>
      </router-link>
    </div> 
  </div>
</template>
<style>
    .div-circle-rotate {
        width: 40%;
        animation: rotate_circle_div 5s infinite;
      }
    .div-circle-rotate:after{
        content: "";
        padding-bottom: 100%;
    }
    @keyframes rotate_circle_div {
      50% {transform: rotate(360deg);}
    }
</style>
<script>
export default {
    name: "NotFound"
}
</script>